import Chip from '@mui/material/Chip';
import type { ChipProps } from '@mui/material/Chip';
import type { OpportunityRequestI } from 'types';

type Status = OpportunityRequestI['status'];

const STATUS_CONFIG: Record<Status, { label: string; color: ChipProps['color'] }> = {
  pending: { label: 'Solicitud pendiente', color: 'warning' },
  approved: { label: 'Oportunidad aprobada', color: 'success' },
  rejected: { label: 'Solicitud rechazada', color: 'error' },
  used: { label: 'Usada', color: 'default' },
};

interface Props {
  status: Status;
  size?: ChipProps['size'];
}

/**
 * MUI Chip showing the opportunity request status with appropriate color.
 */
export default function OpportunityStatusChip({ status, size = 'small' }: Props) {
  const config = STATUS_CONFIG[status];
  return <Chip label={config.label} color={config.color} size={size} />;
}
